/** @jsx jsx */
import { Flex, jsx } from 'theme-ui'
import { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-use'
import { AddedToCartNotification } from '../Notification/AddedToCart/AddedToCart'
import NotificationBar from '../Notification/Bar'
import { CartProvider } from '../Mini-Cart/CartContext'
import { CategoryCarousel } from '../CategoryCarousel'
import BazaarVoiceScript from '../Reviews/Script/BazaarVoiceScript'
import { CartWrapper } from '../CartWrapper/CartWrapper'
import { DuneBuggy } from './DuneBuggy'
import StickyBar from './StickyBar'
import MessageSnackbar from './MessageSnackbar'
import { UsableNetAssistiveContext } from './UsableNetAssistiveContext'
import Footer from '~/components/Footer'
import useNavigationQuery from '~/hooks/graphql/queries/intlQueries/use-navigation'
import { localeFromPathname } from '~/utils/intl/localePrefix'
import useURLPromotion from '~/hooks/components/use-url-promotion'
import MessageContext from '~/contexts/MessageContext'

const Layout = ({
  children,
  navBackgroundColor,
  isHome,
  logoColors,
  theme,
  footerColors,
}) => {
  const [message] = useContext(MessageContext)
  const [pauseBuggyAnimation, setPauseBuggyAnimation] = useState(false)

  const isCart =
    typeof window !== 'undefined' && window.location.pathname.includes('cart')

  const location = useLocation()
  const { tabs } = useNavigationQuery(
    localeFromPathname(location.pathname).code,
  )

  useURLPromotion({ codeString: 'promo' })

  return (
    <CartProvider>
      <UsableNetAssistiveContext>
        <MessageSnackbar message={message} />
        <CartWrapper />
        <BazaarVoiceScript theme={theme} />
        <Flex
          sx={t => ({
            minHeight: '100vh',
            flexDirection: 'column',
            overflow: 'hidden',
            background: t.colors.backgroundGradient,
          })}
        >
          <DuneBuggy pauseBuggyAnimation={pauseBuggyAnimation} />
          {/* Get size without doing wacky JS */}
          <div sx={{ visibility: 'hidden' }} aria-hidden="true">
            <NotificationBar />
            <div
              sx={{
                height: [`${isHome ? '0px' : '80px'}`, '80px'],
              }}
            ></div>
          </div>

          <StickyBar
            background={navBackgroundColor && navBackgroundColor}
            logoColors={logoColors}
            tabs={tabs.filter(
              tab => tab.navSectionName !== 'Category Carousel Mobile',
            )}
          />

          {isHome && tabs && (
            <CategoryCarousel
              tab={tabs?.find(
                tab => tab.navSectionName === 'Category Carousel Mobile',
              )}
            />
          )}

          <Flex sx={{ flex: 1, flexDirection: 'column', position: 'relative' }}>
            {children}
          </Flex>
          {!isCart && (
            <Footer
              pauseBuggyAnimation={pauseBuggyAnimation}
              setPauseBuggyAnimation={setPauseBuggyAnimation}
              footerColors={footerColors}
            />
          )}
        </Flex>
        <AddedToCartNotification />
      </UsableNetAssistiveContext>
    </CartProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  footerColors: PropTypes.object,
}

export default Layout
